/** Matches `vishmaker_current_chat_session` in sharedChatService. */
export const CURRENT_CHAT_SESSION_KEY = 'vishmaker_current_chat_session';

export function getCurrentProjectIdFromLocalStorage(): string | null {
  try {
    const raw = localStorage.getItem(CURRENT_CHAT_SESSION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { projectId?: string };
    const id = parsed.projectId?.trim();
    return id || null;
  } catch {
    return null;
  }
}

/** Manual requirement uiid: `man_` + first 5 hex chars of a new UUID. */
export function generateManualRequirementUiid(): string {
  const hex = crypto.randomUUID().replace(/-/g, '');
  return `man_${hex.slice(0, 5)}`;
}
